export const CONTENT_TYPES = Object.freeze([
    {
        id: 1,
        key_name: 'documents.scorm_package',
        name: 'Scorm/xAPI Paketi',
        icon: 'icon-feather-package',
        accept: 'application/zip',
    },
    {
        id: 2,
        key_name: 'documents.visual_document',
        name: 'Görsel Dokümanı',
        icon: 'icon-feather-image',
        accept: 'image/*',
    },
    {
        id: 3,
        key_name: 'documents.pdf_document',
        name: 'PDF Dokümanı',
        icon: 'icon-feather-file-text',
        accept: 'application/pdf',
    },
    {
        id: 4,
        key_name: 'documents.word_document',
        name: 'Word Dokümanı',
        icon: 'icon-feather-file',
        accept: '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    },
    {
        id: 5,
        key_name: 'documents.powerpoint_document',
        name: 'Powerpoint Dokümanı',
        icon: 'icon-feather-file-text',
        accept: '.pps,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation',
    },
    {
        id: 6,
        key_name: 'documents.audio_document',
        name: 'Ses Dokümanı',
        icon: 'icon-feather-volume-2',
        accept: 'audio/*',
    },
    {
        id: 7,
        key_name: 'documents.video_document',
        name: 'Video Dokümanı',
        icon: 'icon-feather-film',
        accept: 'video/mp4',
    },
    {
        id: 8,
        key_name: 'documents.video_url',
        name: 'Video URL',
        icon: 'icon-feather-youtube',
        accept: 'url',
    },
    {
        id: 9,
        key_name: 'documents.url',
        name: 'URL',
        icon: 'icon-feather-link-2',
        accept: 'url',
    },
    {
        id: 11,
        key_name: 'documents.program',
        name: 'Program',
        icon: 'icon-feather-package',
        accept: 'id',
    },
    {
        id: 12,
        key_name: 'documents.exam',
        name: 'Sınav',
        icon: 'icon-feather-book-open',
        accept: 'id',
    },
    {
        id: 13,
        key_name: 'documents.survey',
        name: 'Anket',
        icon: 'icon-feather-clipboard',
        accept: 'id',
    },
    {
        id: 14,
        key_name: 'documents.classroom_education',
        name: 'Sınıf İçi Eğitim',
        icon: 'icon-feather-book-open',
        accept: 'form',
    },
    {
        id: 15,
        key_name: 'documents.check_list_item',
        name: 'Kontrol Listesi',
        icon: 'icon-feather-book-open',
        accept: 'form',
    },
    {
        id: 16,
        key_name: 'documents.mission',
        name: 'Görev',
        icon: 'icon-feather-book-open',
        accept: 'form',
    },
    {
        id: 17,
        key_name: 'documents.information_content',
        name: 'Bilgi İçeriği',
        icon: 'icon-feather-book-open',
        accept: 'form',
    },
    {
        id: 18,
        key_name: 'documents.webinar',
        name: 'Webinar',
        icon: 'icon-feather-book-open',
        accept: 'form',
    },
    {
        id: 19,
        key_name: 'documents.jitsi',
        name: 'Jitsi URL',
        icon: 'icon-feather-link-2',
        accept: 'url',
    },
]);

export const CATEGORY_IDS = Object.freeze({
    scormPackage: 1,
    visualDocument: 2,
    pdfDocument: 3,
    wordDocument: 4,
    powerpointDocument: 5,
    audioDocument: 6,
    videoDocument: 7,
    videoUrl: 8,
    url: 9,
    program: 11,
    exam: 12,
    survey: 13,
    classroomEducation: 14,
    checkListItem: 15,
    mission: 16,
    informationContent: 17,
    webinar: 18,
    jitsi: 19
});
